import { Link } from "react-router-dom";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import spartaLogo from '../../../assets/img/sparta_logo.png';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ForumIcon from '@mui/icons-material/Forum';
import UserInfo from './UserInfo';
import { Grid, Button, Tooltip, Badge, IconButton } from '@mui/material';
import ReportAnIssue from '../../../lease_management/header_action/ReportAnIssue/ReportAnIssue';
import { useState } from "react";
import AppSwitchModal from "../../../lease_management/header_action/app_switch/AppSwitchModal";
import appConfig from "../../../config";

const lmApplicationId = 33;

const PryHeader = () => {
      const [reportAnIssue, setReportAnIssue] = useState({ modal: false, data: null, })
      const [SwitchApp, setswitchApp] = useState({ modal: false, data: null, })
      const domain = appConfig.domain.subDomian;
  return (
    <>
    <header className='lm-primary-header'>
      <Grid container alignItems='center' spacing={1} className="lm-header-container">
        <Grid size={{ xs: 12, sm: 12, md: 4 }} className="lm-header-content">
          <ul className='list-inline left-items'>
              <li className="list-inline-item" style={{ paddingTop: "10px",cursor:"pointer" }}>
                <a
                  href={domain}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="sparta-logo"
                >
                  <img src={spartaLogo} alt="logo" />
                </a>
              </li>
            <li className="list-inline-item">
              <Button
                size='small'
                className="app-switcher"
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={() => setswitchApp({ modal: true, data: null })}
                endIcon={<ArrowDropDownIcon />}>
                Lease Management
              </Button>
            </li>
          </ul>
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 8 }} className="header-right-item">
          <div className='pry-nav'>
            <div className='header-right-item short-icons'>
              <ul className='list-inline'>
                <li className="list-inline-item">
                  <a href={`${domain}whats-new?application=${lmApplicationId}`} target="_blank" rel="noopener noreferrer">
                    <Tooltip title="What's New" arrow><RecordVoiceOverIcon color='primary' fontSize='small' /></Tooltip>
                  </a>
                </li>
                <li className="list-inline-item">
                  <Tooltip title="Report An Issue" arrow><HeadsetMicIcon color="primary" fontSize="small" onClick={() => setReportAnIssue({ modal: true, data: null })} /></Tooltip>
                </li>
                  <li className="list-inline-item">
                    <Tooltip title="FAQ's" arrow>
                      <IconButton onClick={() => window.open(`${domain}faqs?application=33`, "_blank")}><ForumIcon color='primary' fontSize='small' /></IconButton>
                    </Tooltip>
                  </li>
                <li className="list-inline-item">
                  <a href={`${domain}notifications`} target="_blank" rel="noopener noreferrer">
                    <Tooltip title='Notifications' arrow>
                      <Badge style={{ display: 'inline-block' }} color="error" max={99}>
                        <NotificationsActiveIcon color='primary'/>
                      </Badge>
                    </Tooltip>
                  </a>
                </li>
              </ul>
            </div>
            <div className='header-right-item'>
              <UserInfo />
            </div>
          </div>
        </Grid>
      </Grid>
    </header>
    {
      reportAnIssue?.modal &&
      <ReportAnIssue
      onToggleModal={() => setReportAnIssue({ modal: false, data: null, mode: '' })}
      
      />
    }
    {
      SwitchApp.modal &&
      <AppSwitchModal
      onToggleModal={() => setswitchApp({ modal: false, data: null, mode: '' })}
      
      />
    }
    </>
  )
}
export default (PryHeader);
